import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/AboutPage.css";
import "../styles/HomePage.css";
import "../styles/ProfilePage.css";
import { getIdentifier } from "../utils/auth";

const GET_PUBLIC_PROFILE_URL =
  "https://squid-app-6s2hc.ondigitalocean.app/get-public-profile";

export default function PublicProfilePage() {
  const navigate = useNavigate();
  const { username } = useParams();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const [contactOpen, setContactOpen] = useState(false);

const [message, setMessage] = useState("");
const [sending, setSending] = useState(false);
const [sent, setSent] = useState(false);

const sendMessage = async () => {

  if (!message.trim()) return;

  setSending(true);

  try {

    const res = await fetch(
      "https://squid-app-6s2hc.ondigitalocean.app/send-message",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          recipientUsername: profile.username,
          message,
          email: getIdentifier()
        })
      }
    );

    const data = await res.json();

     if (data.success) {

  setSent(true);
  setMessage("");

  setTimeout(() => {

    setContactOpen(false);
    setSent(false);

  }, 1200);

  }
  }
 catch (err) {

    console.error(err);

  }

  setSending(false);

};

  
  useEffect(() => {
    async function loadProfile() {
      try {
        const res = await fetch(GET_PUBLIC_PROFILE_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username,
          }),
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message);
        }

        setProfile(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    loadProfile();
  }, [username]);

  if (loading) {
    return (
      <main className="profile-page">
        loading...
      </main>
    );
  }

  if (!profile) {
    return (
      <main className="profile-page">
        profile not found
      </main>
    );
  }

  const interests =
    Array.isArray(profile.interests)
      ? profile.interests
      : [];

  const avatarLetter =
    profile.name?.slice(0, 1) ||
    profile.username?.slice(0, 1) ||
    "•";

  return (
    <main className="profile-page">

         <button
        className="contact-back"
        onClick={() => navigate(-1)}
      >
        ← back
      </button>

      <section className="panel active panel-elevated profile-preview centered-panel">

        <div className="preview-top">

 <div className="avatar">
  {profile.avatarUrl ? (
    <img
      src={profile.avatarUrl}
      alt={`${profile.name || profile.username} avatar`}
    />
  ) : (
    <div className="avatar-fallback">
      {avatarLetter}
    </div>
  )}
</div>
  <div className="profile-heading">

    <div className="profile-name">
      {profile.name}
    </div>

    <div className="public-username">
      @{profile.username}

      {profile.isBusiness && (
        <span className="business-status">
          BUSINESS · {profile.isVettedBusiness ? "VETTED" : "NOT VETTED"}
        </span>
      )}
    </div>

  </div>

</div>

        <div className="profile-meta-group">

          {profile.location && (
            <div className="profile-meta">
              📍 {profile.location}
            </div>
          )}

          {profile.website && (
            <div className="profile-meta">
              ↗ {profile.website}
            </div>
          )}

        </div>

        {interests.length > 0 && (
          <div className="collector-section">

            <div className="section-heading">
              collects
            </div>

            <div className="collector-items">
              {interests.map((interest) => (
                <div key={interest}>
                  {interest}
                </div>
              ))}
            </div>

          </div>
        )}

{profile.bio?.trim().length > 0 && (
  <>
    <div className="section-heading">
      the collector's story
    </div>

    <p className="public-bio">
      {profile.bio}
    </p>
  </>
)}
        <div className="preview-actions">

  <button
    className="community-cta outline collections-cta"
    onClick={() =>
      navigate(`/u/${profile.username}/collections`)
    }
  >
    view collections
  </button>

  {profile.allowCollectionContact && (
    <button
  className="community-cta collections-cta"
  onClick={() => setContactOpen(true)}
>
  contact collector
</button>
  )}

</div>

      </section>
{contactOpen && (

  <div
    className="vc-modal-overlay"
    onClick={() => setContactOpen(false)}
  >
    <div
      className="vc-modal"
      onClick={(e) => e.stopPropagation()}
    >

      <button
        className="vc-modal-close"
        onClick={() => setContactOpen(false)}
      >
        ×
      </button>

      <p className="vc-modal-title">
        contact collector
      </p>

      <div className="vc-contact-form">

        <textarea
          className="vc-share-input"
          rows={8}
          placeholder="insert your message here"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button
          className="vc-share-copy"
          onClick={sendMessage}
          disabled={sending}
        >
          {
            sending
              ? "sending..."
              : sent
              ? "sent ✓"
              : "send"
          }
        </button>

      </div>

    </div>
  </div>

)}
    </main>
  );
}